import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ProfileView } from '../components/views/profileView'

/** Account → Your profile (sidebar user menu → "View profile"). Every org. */
function Profile() {
    return (
        <div className="profile">
            <Sidebar />
            <MainView>
                <ProfileView />
            </MainView>
        </div>
    )
}

export default Profile
